import { useEffect, useState } from "react";
import { registerPopup } from "./popupController";

export default function PopupPortal() {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    // 👇 registramos la función que abre el popup
    registerPopup(setPopup);
  }, []);

  if (!popup) return null;

  return (
    <div id='ese' style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: 300,
      height: 200,
      background: "#f6f7f9",
      zIndex: 9999,
      padding: 10
    }}>
      <h3>{popup.titulo}</h3>
      <div
        dangerouslySetInnerHTML={{ __html: popup.contenido }}
      />
      <button onClick={() => setPopup(null)}>Cerrar</button>
    </div>
  );
}
